import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { User } from "@models";
import { AuthService, UserService } from "@services";
import { selectCurrentUser, setCurrentUser, Store } from "@store";
import { Observable, map, of, switchMap, take, tap } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _userService: UserService,
    private _store: Store,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    return this._authService.isAuthenticated().pipe(
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          this._router.navigate(["/auth/login"], { queryParams: next.queryParams });
          return of(false);
        }

        return this._store.select(selectCurrentUser).pipe(
          take(1),
          switchMap((user) => {
            if (!user?.id) {
              return this._userService.getCurrentUser().pipe(
                tap((result: User) => {
                  this._store.dispatch(setCurrentUser({ user: result }));
                }),
                map(() => true),
              );
            }

            return of(true);
          }),
        );
      }),
    );
  }
}
